import { useState } from 'react'
import { getAccessToken } from '../../storage/auth'

export const useDownload = () => {
  let accessToken = getAccessToken()

  const [active, updateActive] = useState(false)

  const download = (service, endpoint) => {
    try {
      updateActive(true)
      setTimeout(() => updateActive(false), 10000)

      const a = document.createElement('a')
      // An endpoint that already has a query (a report's source filter) gets
      // auth added to it, not a second "?".
      const join = endpoint.includes('?') ? '&' : '?'
      a.href = `${service}/${endpoint}${join}auth=${accessToken}`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    } catch (e) {
      debugger
    }
  }

  return { active, download }
}

export const useDownloadPresign = () => {
  const [active, updateActive] = useState(false)

  const download = url => {
    try {
      updateActive(true)
      setTimeout(() => updateActive(false), 10000)

      const a = document.createElement('a')
      a.href = url
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    } catch (e) {
      debugger
    }
  }

  return { active, download }
}
